/**
 * /* SETTINGS
 *
 * @format
 */

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_TOKEN = 'SET_TOKEN';
